import React, { useState, useEffect } from 'react'
import { Button, Form } from 'react-bootstrap'
import { FaPlus, FaTrashAlt, FaTimes } from 'react-icons/fa'
import { FormCheck } from 'react-bootstrap'
import './TaxSettings.css'
import {
  GetTaxSettings,
  CreateAndUpdateTaxSettings,
} from '../../../api/Webservices'
import { showToast, ToastMessage } from '../../Shared/ToastMessage'

const TaxSettingsDrawer = ({ show, onClose, onSave }) => {
  const [taxSettings, setTaxSettings] = useState({
    registrationNumber: '',
    taxes: [],
    displayOption: 'include',
  })

  const handleAddTax = () => {
    setTaxSettings({
      ...taxSettings,
      taxes: [...taxSettings.taxes, { name: '', percentage: '' }],
    })
  }

  const handleRemoveTax = (index) => {
    const updatedTaxes = [...taxSettings.taxes]
    updatedTaxes.splice(index, 1)
    setTaxSettings({
      ...taxSettings,
      taxes: updatedTaxes,
    })
  }

  const handleTaxChange = (index, field, value) => {
    const updatedTaxes = [...taxSettings.taxes]
    updatedTaxes[index] = { ...updatedTaxes[index], [field]: value }
    setTaxSettings({
      ...taxSettings,
      taxes: updatedTaxes,
    })
  }

  const handleSaveChanges = async () => {
    try {
      const eventId = localStorage.getItem('eventId')

      const payload = {
        event_id: Number(eventId),
        tax_settings: {
          tax_registration_number: taxSettings.registrationNumber,
          tax_display:
            taxSettings.displayOption === 'add' ? 'add_to_total' : 'include',
          tax_options: taxSettings.taxes.map((tax) => ({
            tax_name: tax.name,
            tax_percentage: Number(tax.percentage),
          })),
        },
      }

      const response = await CreateAndUpdateTaxSettings(payload)

      console.log('Tax settings updated successfully:', response)
      console.log('Saved Tax Options:', payload.tax_settings.tax_options)
      showToast('Tax settings updated successfully', 'success')

      if (onSave) {
        onSave()
      }

      setTimeout(() => {
        onClose()
      }, 2000)
    } catch (error) {
      console.error('Failed to update tax settings:', error)
      showToast('Failed to update tax settings', 'error')
    }
  }

  useEffect(() => {
    const fetchTaxSettings = async () => {
      try {
        const eventId = localStorage.getItem('eventId')
        const response = await GetTaxSettings(eventId)

        console.log('Tax settings fetched successfully:', response)

        if (
          response &&
          response.event_settings &&
          response.event_settings.tax_settings
        ) {
          const taxSettingsData = response.event_settings.tax_settings

          const formattedTaxSettings = {
            registrationNumber: taxSettingsData.tax_registration_number || '',
            displayOption:
              taxSettingsData.tax_display === 'add_to_total'
                ? 'add'
                : 'include',
            taxes: taxSettingsData.tax_options.map((tax) => ({
              name: tax.tax_name,
              percentage: tax.tax_percentage.toString(),
            })),
          }

          setTaxSettings(formattedTaxSettings)
          console.log('Fetched Tax Options:', taxSettingsData.tax_options)
        }
      } catch (error) {
        console.error('Error fetching tax settings:', error)
      }
    }

    fetchTaxSettings()
  }, [])

  return (
    <>
      <ToastMessage />
      <div
        className={`tax-settings-drawer extraspace_search_div1 search_div ${
          show ? 'show open' : ''
        }`}
      >
        <div className="card drawer-content">
          <div className="member_edit_pop_flex mb-3">
            <h5>Tax Settings</h5>
            <button onClick={onClose} className="search_toggle btn btn-danger">
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="body">
            <div className="">
              <p className="text-muted mb-4">
                Add the tax methods that will be applied to the tickets &
                add-ons
              </p>

              <div className="form-group mb-4">
                <label>
                  Tax Registration Number <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={taxSettings.registrationNumber}
                  onChange={(e) =>
                    setTaxSettings({
                      ...taxSettings,
                      registrationNumber: e.target.value,
                    })
                  }
                />
              </div>

              {taxSettings.taxes.map((tax, index) => (
                <div key={index} className="tax-row mb-4 add_attendites_model">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label className="form-label">
                          Tax Name{' '}
                          {index === 0 && (
                            <span className="text-danger">*</span>
                          )}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="e.g. VAT, GST"
                          value={tax.name}
                          onChange={(e) =>
                            handleTaxChange(index, 'name', e.target.value)
                          }
                        />
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="form-group">
                        <label className="form-label">
                          Tax Percentage{' '}
                          {index === 0 && (
                            <span className="text-danger">*</span>
                          )}
                        </label>
                        <div className="tex_price_flex">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter tax percentage"
                            value={tax.percentage}
                            onChange={(e) =>
                              handleTaxChange(
                                index,
                                'percentage',
                                e.target.value
                              )
                            }
                          />
                          <span className="input-group-text">%</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-1 d-flex align-items-center">
                      {index > 0 && (
                        <div>
                          <label className="form-label"></label>
                          <button
                            className="search_toggle btn btn-danger"
                            onClick={() => handleRemoveTax(index)}
                          >
                            <i className="fa fa-trash-o"></i>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}

              <button className="btn btn-primary mb-2" onClick={handleAddTax}>
                <FaPlus className="me-2" /> Add New Tax
              </button>

              <div className="form-group">
                <label style={{ marginBottom: '3rem' }}>
                  How would you like to display the tax?{' '}
                  <span className="text-danger">*</span>
                </label>
                <div>
                  <FormCheck
                    type="radio"
                    id="add-tax"
                    name="taxDisplay"
                    label="Add tax to the total amount at checkout"
                    checked={taxSettings.displayOption === 'add'}
                    onChange={() =>
                      setTaxSettings({ ...taxSettings, displayOption: 'add' })
                    }
                  />
                  <FormCheck
                    type="radio"
                    id="include-tax"
                    name="taxDisplay"
                    label="Include tax in the ticket price"
                    checked={taxSettings.displayOption === 'include'}
                    onChange={() =>
                      setTaxSettings({
                        ...taxSettings,
                        displayOption: 'include',
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="">
              <button
                onClick={handleSaveChanges}
                className="btn btn-outline-primary mb-2"
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TaxSettingsDrawer
